import React from 'react';
import { SubscriberData } from '../types';
import { IdView } from '../../../../components';

interface SubscriberIdCellProps {
  subscriber: SubscriberData;
}

const SubscriberIdCell: React.FC<SubscriberIdCellProps> = ({ subscriber }) => {
  return <IdView textToCopy={subscriber.id}>{subscriber.id?.slice(-4)}</IdView>;
};

export default SubscriberIdCell;
